/**
 * 作者：张小彤
 * 时间：2016/12/12
 * 描述：下载
 */
import React, {Component} from 'react';

import './download.scss';
import andzip from './images/1.rar';
import ioszip from './images/2.rar';

export default class Download extends Component{
    componentDidMount(){
        $('.downlist ').on('click','li',function(){
            $(this).addClass('downactive').siblings().removeClass('downactive');
            $('.downcontaions > div').removeClass('block').addClass('none').eq($(this).index()).removeClass('none').addClass('block');
        })
    }
    render(){
        return(
            <div className="tabcon">
                <div className="downloadcon">
                    <div className="downloadtab">
                        <ul className="c downlist">
                            <li className="downactive"><a href="javascript:void(0);" className="and"></a></li>
                            <li><a href="javascript:void(0);" className="ios"></a></li>
                        </ul>
                    </div>
                    <div className="downcontaions">
                        <div className="downcon block">
                            <a className="downbtn" href={andzip}></a>
                            <h3>最新修改</h3>
                            <div className="year">2016</div>
                            <dl>
                                <dt className="time">12.07　　V.2.0.0</dt>
                                <dd className="dd">
                                    <p>1.增加真正的游客登录功能，实现同一设备卸载游戏再次安装使用的游客账号为同一个</p>
                                    <p>2.增加手机注册功能，并且推荐手机注册，如不用手机注册还可以自己定义账号</p>
                                    <p>3.用户中心增加实名认证功能，当账号发生纠纷时，蓝港会裁定实名认证的用户拥有账号</p>
                                    <p>4.在网络传输过有一期的DES更改为RSA，由之前的http协议改为https协议</p>
                                    <p>5.动态控制悬浮按钮是否显示已经悬浮按钮中的论坛是否显示</p>
                                </dd>
                            </dl>

                            <dl>
                                <dt className="time">06.16　　V.1.2.0</dt>
                                <dd className="dd">
                                    <p>1.美化了登录、注册、用户协议、界面</p>
                                    <p>2.支付增加了透传参数</p>
                                    <p>3.去掉了短信支付</p>
                                    <p>4.解决了部分手机上银联支付打不开问题</p>

                                </dd>
                            </dl>
                        </div>
                        <div className="downcon">
                            <a className="downbtn" href={ioszip}></a>
                            <h3>最新修改</h3>
                            <div className="year">2016</div>
                            <dl>
                                <dt className="time">12.07　　V.2.0.0</dt>
                                <dd className="dd">
                                    <p>1.增加真正的游客登录功能，实现同一设备卸载游戏再次安装使用的游客账号为同一个</p>
                                    <p>2.增加手机注册功能，并且推荐手机注册，如不用手机注册还可以自己定义账号</p>
                                    <p>3.用户中心增加实名认证功能，当账号发生纠纷时，蓝港会裁定实名认证的用户拥有账号</p>
                                    <p>4.在网络传输过有一期的DES更改为RSA，由之前的http协议改为https协议</p>
                                    <p>5.动态控制悬浮按钮是否显示已经悬浮按钮中的论坛是否显示</p>
                                </dd>
                            </dl>

                            <dl>
                                <dt className="time">06.16　　V.1.2.0</dt>
                                <dd className="dd">
                                    <p>1.美化了登录、注册、用户协议、界面</p>
                                    <p>2.支付增加了透传参数</p>
                                    <p>3.去掉了短信支付</p>
                                    <p>4.解决了部分手机上银联支付打不开问题</p>

                                </dd>
                            </dl>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./D:/front-end-svn/webpack/src/project/sdk/components/download/download.jsx